<template>
    <div>
        <div class="form-group form-search">
            <Autocomplete
                :search="search"
                placeholder="Search actor"
                aria-label="Search actor"
                :get-result-value="getResult"
                @submit="handleSubmit"
                ></Autocomplete>
        </div>
        <p class="text-center">
            <label><input type="checkbox" v-model="showSeasons"> Show Seasons</label>
        </p>
        <ActorCard :info="actorInfo" :credits="actorCredits" :showSeasons="showSeasons"/>

        <ul v-if="errors && errors.length">
            <li v-for="error of errors">
                {{error.message}}
            </li>
        </ul>
    </div>
</template>

<script>
    import {ActorLookup, URLQuery} from './../tmdb';
    import axios from 'axios'
    import moment from 'moment';

    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'

    // import actorCreditsA from './../actorCredits.json';
    // import actorInfoA from './../actorInfo.json';

    import ActorCard from './ActorCard';

    var DEBUG = false;
    var personIDs = require('./../person_ids_pop_over_2_2.json');

    export default {
        name: 'ActorSearch',
        components: {
            Autocomplete,
            ActorCard
        },
        data() {
            return {
                errors: [],
                actorInfo: null,
                actorCredits: [{
                    showCredits: null
                }],
                showSeasons: true
            }
        },
        methods: {
            async searchChange(input) {
                this.input = input;

                console.log("user input", input);

                const [actorInfo, actorCredits] = await Promise.all([
                    ActorLookup(`/person/${input}`),
                    ActorLookup(`/person/${input}/combined_credits`)
                ]);

                for (var credit of actorCredits.data.cast) {
                    if (credit.media_type === 'tv' && credit.episode_count > 1) {
                        // For every tv show, if they have multiple episodes look up all the air dates
                        const [showCredit] = await Promise.all([
                            ActorLookup(`/credit/${credit.credit_id}`),
                        ]);

                        credit.showCredits = [];
                        credit.showCredits = showCredit.data.media
                    } else {
                        credit.showCredits = null;
                    }
                }

                // Set return values to vue data
                this.actorInfo = actorInfo.data;
                this.actorCredits = actorCredits.data.cast;
            },
            search(input) {
                input = input.toLowerCase()

                return new Promise(resolve => {
                    if (input.length < 3)
                        return resolve([])
                    else {
                        // Filter the data by users input to only show matches
                        var filteredPeople = personIDs.filter(person => person.name.toLowerCase().indexOf(input) > -1)
                        return resolve(filteredPeople)
                    }
                })
            },
            getResult(result) {
                return result.name;
            },
            handleSubmit(result) {
                this.searchChange(result.id)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .autocomplete-result-list li {
        text-align: left;
        cursor: pointer;
    }

    .form-search {
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
</style>
